// PRC EDITED: cart drawer product suggestions (estimate 4093671, line 4).
// Loads sections/prc-cart-recommendations.liquid for the first cart item: complementary products
// (Search & Discovery) first, related products as the fallback. Single-variant suggestions add to
// the cart and re-render the drawer the same way Dawn's product form does.
if (!customElements.get('prc-cart-recommendations')) {
  customElements.define(
    'prc-cart-recommendations',
    class PrcCartRecommendations extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.productId) return;
        this.addEventListener('click', this.onClick.bind(this));
        this.load('complementary').then((found) => found || this.load('related'));
      }

      load(intent) {
        const url = `${this.dataset.url}?section_id=prc-cart-recommendations&product_id=${this.dataset.productId}&limit=10&intent=${intent}`;

        return fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html').querySelector('.prc-cart-recs');
            if (!html) return false;
            this.innerHTML = html.outerHTML;
            return true;
          })
          .catch((e) => {
            console.error(e);
            return false;
          });
      }

      onClick(event) {
        const button = event.target.closest('[data-prc-add-variant]');
        if (!button) return;

        const cartDrawer = document.querySelector('cart-drawer');
        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');

        fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(button.dataset.prcAddVariant), quantity: 1 }],
            sections: cartDrawer.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) throw new Error(response.description || response.message);

            // /cart/add.js with `items` returns { items: [...] }; renderContents expects the added item's id.
            response.id = response.items?.[0]?.id;
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'prc-cart-recommendations', cartData: response });
            cartDrawer.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
            button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
          });
      }
    }
  );
}
